import * as React from "react"
import {useStaticQuery, graphql, Script} from "gatsby"

function Seo({description, title, ogImage, lang, children}) {
  const {site} = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title || '';

  title = title || defaultTitle;

  return (
    <>
      <html lang={`${lang?.slug ?? 'en'}`}/>
      <title>{title}</title>
      <meta name="description" content={metaDescription}/>
      <meta property="og:title" content={title}/>
      <meta property="og:description" content={metaDescription}/>
      <meta property="og:type" content="website"/>
      <meta property="og:image" content={ogImage || "/og.png"}/>
      <meta property="og:image:width" content="1200"/>
      <meta property="og:image:width" content="630"/>

      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``}/>
      <meta name="twitter:title" content={title}/>
      <meta name="twitter:description" content={metaDescription}/>
      {children}
      {(lang?.slug === 'zh' || lang?.slug === 'ja') && (
        <Script>{`(function(d) {
          var config = {
          kitId: 'csv5mwo',
          async: true
          },
          h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\\bwf-loading\\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
          })(document);`}
        </Script>
      )}
    </>
  )
}

export default Seo
